




























import { Size } from '@front-app/components/constants';
import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
	props: {
		size: {
			type: String as PropType<Size>,
			default: Size.LARGE,
		},
		inline: Boolean,
		hideLabel: Boolean,
	},
	setup() {
		return {
			Size,
		};
	},
});
